import React from 'react';
import Carousel from 'react-elastic-carousel';
import TrainingCard from '../../training/components/TrainingCard';
import windowService from '../../../services/windowService';
import { TrainingItem } from '../models/trainingItem';
import { carouselControls } from '../../../components/CarouselElements';

const redirectToCompilationTraining = (compilationId: string, trainingId: string) =>
  windowService.redirectTo(`#/catalog/compilation/${compilationId}/${trainingId}`);

const TrainingCompilationCarousel = ({
  compilationId,
  trainingItems,
  canRedirect = true,
}: {
  compilationId: string;
  trainingItems: TrainingItem[];
  canRedirect?: boolean;
}) => {
  const breakPoints = [
    { width: 1, itemsToShow: 1, itemsToScroll: 1 },
    { width: 629, itemsToShow: 2, itemsToScroll: 2 },
    { width: 992, itemsToShow: 3, itemsToScroll: 3 },
  ];

  return (
    <Carousel
      className="training-compilation-carousel"
      initialFirstItem={0}
      breakPoints={breakPoints}
      renderArrow={carouselControls}
      pagination={false}
      itemPadding={[0, 12, 12, 12]}
      isRTL={false}
    >
      {trainingItems.map(training => (
        <TrainingCard
          key={training.id}
          training={training}
          redirectToTraining={() => redirectToCompilationTraining(compilationId, training.id)}
          canRedirect={canRedirect}
        />
      ))}
    </Carousel>
  );
};

export default TrainingCompilationCarousel;
